import type { AccessionListFilter } from "@blis/shared/schemas/accession";

/** True when the merged list filter would exclude rows beyond an unfiltered lab-scoped list. */
export function accessionListHasNarrowingFilters(
  f: AccessionListFilter,
): boolean {
  return (
    f.myAccessions ||
    f.hasSendOut ||
    f.status.length > 0 ||
    f.holdStatus.length > 0 ||
    f.client.length > 0 ||
    f.sharedClient.length > 0 ||
    f.billToOrg.length > 0 ||
    f.splitBillingOrgs.length > 0 ||
    f.test.length > 0 ||
    f.panel.length > 0 ||
    f.testType.length > 0 ||
    f.priority.length > 0 ||
    f.accessionIds.length > 0 ||
    f.labs.length > 0
  );
}
